import { Injectable, Input, NgZone, Output , EventEmitter} from '@angular/core';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import { tap, finalize } from 'rxjs/operators';
import { BaseUrl } from '../framework/constants/url-constants';
import { Utility } from '../framework/utils/utility';
import { ApplicationConstant } from '../framework/constants/app-constant';
import { MatDialog } from '@angular/material/dialog';


const authHeaderString = 'X-Authorization';
const contentTypeHeaderString = 'application/json';

const signInHttpHeaders = new HttpHeaders({
  'Content-Type': contentTypeHeaderString
});

@Injectable()
export class SessionsService {
  @Output() passwordAboutToExpiredFlag: EventEmitter<boolean> = new EventEmitter();

    setPasswordAboutToExpireFlag(flag) {
        localStorage.setItem('passwordCheck', JSON.stringify(flag));
        this.passwordAboutToExpiredFlag.emit(flag);

    }
    constructor(
        private readonly http: HttpClient,
        private readonly router: Router,
        private readonly zone: NgZone,
        private readonly dialogRef: MatDialog
    ) { }

    signin(data: any): any {
        return this.http.post<any>(BaseUrl.USER + '/v3/login', data ,  { headers: signInHttpHeaders, observe: 'response' })
            .pipe(
                tap(resp => {
                    this.resolveSessionParams(resp);

                })
                );
    }

    signout() {
        this.dialogRef.closeAll();
        return this.http.get(BaseUrl.USER + '/logoutUser')
        .pipe(finalize(() => this.onSignoutTap()));
    }

    onSignoutTap() {
        localStorage.clear();
        this.zone.run(() => this.router.navigate(['/sessions/signin']));
    }

    resolveSessionParams(resp) {
        const xAuthToken = resp.headers.get(authHeaderString).split(' ');
        const token = xAuthToken[1];
        if (resp.body.mfaEnabled) {
          localStorage.setItem('shortToken', token);
        }
        else {
          localStorage.setItem('token', token);
        }
        if (resp.body.heartbeat) {
            localStorage.setItem('session', btoa(JSON.stringify(resp.body)));
        }
    }

    hasResource(auth: string[]) {

        if (localStorage.getItem('token') && auth) {
          const payload = atob(localStorage.getItem('token').split('.')[1]);
          const permissions = JSON.parse(payload).listResource;
    
          if (auth[1] && permissions.filter(feature => +feature.fid === +auth[0])[0]) {
            return !!permissions.filter(feature => +feature.fid === +auth[0])[0].opId.find(operation => +operation === +auth[1]);
          } else {
            return !!permissions.find(permission => +permission.fid === +auth[0]);
          }
        }
        return false;
      }

      getRoleId() {
        if (localStorage.getItem('token')) {
          const tokenBody = atob(localStorage.getItem('token').split('.')[1]);
          const payload = JSON.parse(tokenBody);
          return payload.roleId;
        }
        return 0;
      }

      refreshToken() {

        return this.http.get<any>(`${BaseUrl.USER}/refreshToken`, { observe: 'response' })
          .pipe(
            tap(resp => {
              this.resolveVerifySessionParams(resp);
            }));
      }
      isRehabSupervisor(roleList) {
        let isValid = false;
        const roleId = this.getRoleId();
        if(roleId !== -1) {
          const role = Utility.getObjectFromArrayByKeyAndValue(roleList, 'roleId', roleId);
          if(role !== null && role.identifier === 'RHS') {
            isValid = true;
          }
        }
        return isValid;
      }
      getClientOrganizations() {
        const href = `${BaseUrl.USER}/user/organizations`;
        return this.http.get<any>(href);
      }

      getAllClientOrganizations() {
        const href = `${BaseUrl.USER}/manageOrganization/getAllOrginizations`;
        const params = new HttpParams().set('clientId', ApplicationConstant.clientId);
        return this.http.get<any>(href,{ params });
      }

      changeEstablishment(estbId) {
        return this.http.post<any>(`${BaseUrl.USER}/changeEstablishment/${estbId}`, estbId ,  { headers: signInHttpHeaders, observe: 'response' })
        .pipe(
          tap(resp => {
              this.resolveSessionParams(resp);
          }),
        );
      }

      noticeBoardMessage() {
        const data = {"appId" : ApplicationConstant.ApplicationID , "clientId" : ApplicationConstant.clientId}; 
        const href = `${BaseUrl.USER}/notification/notice`;
        return this.http.post<any>(href, data);  
    }

    
sendOTP() {
  return this.http.post<any>(BaseUrl.USER + '/v3/send-otp', { headers: signInHttpHeaders});
}

verifyOTP(data: any): any {
  data.appId = localStorage.getItem('ApplicationID')
  data.clientId = localStorage.getItem('clientId')
  return this.http.post<any>(BaseUrl.USER + '/v3/login', data, { headers: signInHttpHeaders, observe: 'response' })
    .pipe(
      tap(resp => {
        this.resolveSessionParams(resp);

      })
    );
}

resolveVerifySessionParams(resp) {
  const xAuthToken = resp.headers.get(authHeaderString).split(' ');
  const token = xAuthToken[1];
  localStorage.setItem('token', token);
  if (resp.body.heartbeat) {
    localStorage.setItem('session', btoa(JSON.stringify(resp.body)));
  }
}

}
